import { create } from 'zustand';
import { getDeviceWarnings } from '../../../../../api/api';

const INITIAL_MODAL_STATE = {
  isOpen: false,
  deviceId: null,
  serialNumber: '',
};

export const useDeviceWarningsStore = create((set) => ({
  warningsByDeviceId: {},
  ...INITIAL_MODAL_STATE,

  fetchWarnings: async (deviceId) => {
    if (!deviceId) return;

    const data = await getDeviceWarnings(deviceId);
    const warnings = Array.isArray(data?.warnings) ? data.warnings : [];

    set((state) => ({
      warningsByDeviceId: {
        ...state.warningsByDeviceId,
        [deviceId]: warnings,
      },
    }));
  },

  open: (device) => {
    if (!device?.id) return;

    set({
      isOpen: true,
      deviceId: device.id,
      serialNumber: device.serial_number ?? '',
    });
  },

  close: () => set({ ...INITIAL_MODAL_STATE }),
}));
